import { TellescopeModelFromName, useTellescopeInfiniteQuery, useTellescopeMutation } from "@tellescope/tanstack-query";
import { FilePreview } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { FilePreviewDialog } from "../FilePreviewDialog";

export interface TicketAttachmentProps {
  attachment: NonNullable<TellescopeModelFromName<"tickets">["attachments"]>[number];
  deleteFile?: boolean;
  onDelete?: () => void;
  className?: string;
}

export const TicketAttachment = ({ attachment, deleteFile = false, onDelete, className }: TicketAttachmentProps) => {
  const { t } = useTranslation("tickets");

  const deleteFileMutation = useTellescopeMutation({
    model: "files",
    method: "deleteOne",

    onSuccess: () => {
      onDelete?.();
    },
  });

  const fileIdQuery = useTellescopeInfiniteQuery({
    model: "files",
    method: "getSome",
    request: {
      filter: {
        secureName: attachment.secureName,
      },
    },
    enabled: !!deleteFile,
    select: (data) => data.pages.at(0)?.at(0)?.id,
  });

  const handleRemove = () => {
    if (deleteFile && fileIdQuery.data) {
      deleteFileMutation.mutate(fileIdQuery.data);
    } else {
      onDelete?.();
    }
  };

  return (
    <FilePreviewDialog secureName={attachment.secureName} fileType={attachment.type} fileName={attachment.name}>
      <FilePreview
        fileName={attachment.name ?? t("Unnamed attachment")}
        fileType={attachment.type}
        onRemove={onDelete ? handleRemove : undefined}
        maxWidth="150px"
        className={className}
      />
    </FilePreviewDialog>
  );
};
